/**
 * 温馨治愈风格登录页面
 * 使用柔和的渐变背景、治愈系插画、流畅的动画
 */

import React, { useState } from 'react';
import { Button, Form, Input, message, Row, Col } from 'antd';
import { UserOutlined, LockOutlined, SmileOutlined, HeartOutlined } from '@ant-design/icons';
import { login } from '../services/api/auth';
import { useNavigate, Link } from 'react-router-dom';
import './Login.css';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // 温馨文案库
  const tips = [
    '小猫咪正在准备数据~',
    '阳光洒满登录页面~',
    '数据花园正在绽放~',
    '云朵收集着美好~',
    '温暖的一天开始了~'
  ];
  const [tip, setTip] = useState(tips[0]);

  // 登录提交
  const onFinish = async (values: any) => {
    setLoading(true);
    setTip(tips[Math.floor(Math.random() * tips.length)]);

    try {
      const result = await login({
        username: values.username,
        password: values.password
      });

      // 保存 Token
      localStorage.setItem('token', result.accessToken);
      localStorage.setItem('userInfo', JSON.stringify(result));

      const displayName = result.nickname || result.username || '用户';
      message.success('🎉 欢迎回来，' + displayName + '!');

      // 延迟跳转，展示成功动画
      setTimeout(() => {
        navigate('/dashboard');
      }, 800);
    } catch (error: any) {
      console.error('登录失败:', error);
      message.error(error.message || '登录失败，请检查用户名和密码');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* 左侧插画区域 */}
      <div className="login-left">
        <div className="login-illustration">
          <div className="login-sun">
            <HeartOutlined className="login-heart" />
          </div>
          <div className="login-cloud cloud-1">
            <SmileOutlined />
          </div>
          <div className="login-cloud cloud-2">
            ☁️
          </div>
          <div className="login-tree">
            <div className="login-tree-top"></div>
            <div className="login-tree-bottom"></div>
          </div>
        </div>
        <div className="login-quote">
          <p>🌈</p>
          <p>让每一次登录都充满温暖~</p>
        </div>
      </div>

      {/* 右侧登录表单 */}
      <div className="login-right">
        <div className="login-form-wrapper">
          <div className="login-header">
            <div className="login-logo">
              <SmileOutlined className="login-logo-icon" />
              <span className="login-logo-text">FunHub Admin</span>
            </div>
            <div className="login-subtitle">✨ 温暖的后台管理系统</div>
          </div>

          <div className="login-tip">
            <HeartOutlined className="login-tip-icon" />
            <span>{tip}</span>
          </div>

          <Form
            form={form}
            name="login"
            onFinish={onFinish}
            autoComplete="off"
            className="login-form"
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: '请输入用户名!' }]}
              initialValue="admin"
            >
              <Input
                prefix={<UserOutlined className="login-input-icon" />}
                placeholder="用户名（默认：admin）"
                size="large"
                className="login-input"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码!' }]}
              initialValue="admin123"
            >
              <Input.Password
                prefix={<LockOutlined className="login-input-icon" />}
                placeholder="密码（默认：admin123）"
                size="large"
                className="login-input"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                size="large"
                block
                className="login-button"
              >
                {loading ? '登录中...' : '🌸 立即登录'}
              </Button>
            </Form.Item>
          </Form>

          <div className="login-footer">
            <div className="login-footer-text">
              <span>💡 欢迎登录~</span>
            </div>
          </div>
        </div>

        <div className="login-copyright">
          © 2026 FunHub Admin - 用心创造温暖
        </div>

        {/* ICP 备案信息 */}
        <div className="login-icp-footer">
          <p>
            <span>ICP 备案/许可证号：</span>
            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" className="icp-link">
              粤 ICP 备 2021167526 号
            </a>
            <span className="icp-divider">|</span>
            <span>主办单位名称：林秀彬</span>
            <span className="icp-divider">|</span>
            <span>主办单位性质：个人</span>
          </p>
          <p className="icp-sub">
            <span>ICP 备案/许可证号：</span>
            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" className="icp-link">
              粤 ICP 备 2021167526 号 -1
            </a>
            <span className="icp-date">审核通过日期：2021-12-09</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
